import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Stack, Typography } from '@mui/material'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import useModals from 'src/Hooks/useModals'
import { ChargingCardModel } from '../../api/models/charging-card-model'
import { WallboxModel } from 'src/Libs/e-mobility/wallboxes'

export interface UnmanagedModeInfoDialogProps {
  open: boolean
  onClose: () => void
  place: number
  installationId: number
  chargingCards: ChargingCardModel[]
  wallboxes: WallboxModel[]
}

/**
 * Dialog component for displaying information to the user that user is in unmanaged mode
 * Unmanaged mode is when no wallboxes are linked with no cards at all
 */
export const UnmanagedModeInfoDialog: React.FC<UnmanagedModeInfoDialogProps> = ({
  open,
  onClose,
  place,
  installationId,
  wallboxes,
  chargingCards,
}) => {
  const { t } = useCustomTranslation()
  const { openChargingCardToWallboxLinkModal } = useModals()

  const onClickUnderstood = (): void => {
    onClose()
    openChargingCardToWallboxLinkModal({ installationId })
  }

  return (
    <Dialog
      maxWidth="md"
      title={t('emobility.chargingCards.link-charging-cards-and-wallboxes-dialog-title')}
      onClose={onClose}
      place={place}
      actions={{
        secondary: {
          name: t('common.cancel'),
        },
        primary: {
          name: t('emobility.charging-cards.understood'),
          onClick: onClickUnderstood,
        },
      }}
    >
      <Stack>
        <Typography>{t('emobility.charging-cards.unmanaged-mode-info-title')}</Typography>

        <Box mt={4}>
          <Typography>{t('emobility.charging-cards.unmanaged-mode-info-content')}</Typography>
        </Box>
      </Stack>
    </Dialog>
  )
}
